import React from 'react';
import { useAppSelector } from '../../../../hooks/use-app-selector';
import { useLocalStorageState } from 'ahooks';
import { useNavigate } from 'react-router-dom';
import { SubscriptionUpgradeCard } from './SubscriptionUpgradeCard';
import { SetupProgressCard } from './SetupProgressCard';
import {
  isWhitelabelAccount,
  isResellerAccount,
} from '../../../../shared/utils';
import { getAppSettings } from '../../../../selectors';
import { useGlobals } from '../../../../globals-context';
import { BETA_TOGGLES } from '../../../../features/beta/screens/Beta';

type SidebarActionCardsProps = {
  sideMenuCollapsed: boolean;
  onSetupProgressCardClick: () => void;
};

export function SidebarActionCards({
  sideMenuCollapsed,
  onSetupProgressCardClick,
}: SidebarActionCardsProps) {
  const navigate = useNavigate();
  const { trackMethod } = useGlobals() as any;

  const currentMerchant = useAppSelector((state) => state.currentMerchant);
  const { subscriptionPartner } =
    useAppSelector((state) => getAppSettings(state)) || {};

  const packageCode = useAppSelector(
    (state) => state.currentMerchant.packageCode
  );
  const isWhitelabel = isWhitelabelAccount(currentMerchant.whiteLabel);
  const isTrialMerchant = (currentMerchant?.trialDaysLeft || 0) > 0;
  const isReseller = isResellerAccount(subscriptionPartner);

  const showSubscriptionUpgradeCard =
    !isWhitelabel && !isReseller && packageCode !== 'shore_pos_premium';

  const [showBetaSubscriptionUpgradeCard] = useLocalStorageState<boolean>(
    BETA_TOGGLES.subscriptionUpgradeCard.key,
    {
      listenStorageChange: true,
    }
  );

  const [showBetaSetupProgressBanner] = useLocalStorageState<boolean>(
    BETA_TOGGLES.setupProgressBanner.key,
    {
      listenStorageChange: true,
    }
  );

  const handleOnSubscriptionUpgradeCardClick = () => {
    trackMethod('subscription_upgrade_card_clicked', {
      isTrialMerchant,
      trialDaysLeft: currentMerchant?.trialDaysLeft || 0,
    });
    if (isTrialMerchant) {
      navigate('/subscription');
    } else {
      navigate('/subscription/upgrade');
    }
  };

  const handleOnSetupProgressCardClick = () => {
    trackMethod('setup_progress_card_clicked');
    onSetupProgressCardClick();
  };

  return (
    <>
      {showBetaSubscriptionUpgradeCard && showSubscriptionUpgradeCard && (
        <SubscriptionUpgradeCard
          sideMenuCollapsed={sideMenuCollapsed}
          onCardClick={handleOnSubscriptionUpgradeCardClick}
        />
      )}
      {showBetaSetupProgressBanner && (
        <SetupProgressCard
          sideMenuCollapsed={sideMenuCollapsed}
          onCardClick={handleOnSetupProgressCardClick}
        />
      )}
    </>
  );
}
